/**
 * Logs a message to the console when not in production.
 * @param msg The message to display
 * @param domain The optional domain of the message (e.g. Pusher)
 *
 * @example
 * // debugLog('Pusher instance created', 'Pusher')
 * // > [GM/Pusher] Pusher instance created
 */
export function debugLog(msg: string, domain?: string) {
  if (import.meta.env.MODE.startsWith('prod')) return;
  let prefix = 'GM';
  if (domain) prefix += `/${domain}`;
  console.info(`[${prefix}]`, msg);
}
